<template>
    <div class="max-w-lg mx-auto">
        <div class="card">
            <h4 class="card__title">Redigera utskick</h4>
            <text-input
                v-model="subject"
                name="subject"
                label="Ämne"
                :required="true"
            />

            <slot />
        </div>
        <div class="card">
            Antal adresser med e-postadress kopplad till sig: {{ recipientsCount }}
        </div>

        <div class="flex justify-between">
            <a
                class="btn is-ghost btn-lg"
                :href="cancelUrl"
                tabindex="2"
            >
                Avbryt
            </a>
            <button type="submit" class="btn is-primary btn-lg">
                Spara som utkast
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            mailshot: {
                type: Object,
                required: true,
            },
            recipientsCount: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                subject: this.mailshot.subject,
            };
        },
        computed: {
            cancelUrl() {
                return route('admin.mailshots.show', this.mailshot);
            },
        },
    };
</script>
